import { render, staticRenderFns } from "./dashboardcount.vue?vue&type=template&id=42043c04&scoped=true&"
import script from "./dashboardcount.vue?vue&type=script&lang=js&"
export * from "./dashboardcount.vue?vue&type=script&lang=js&"
import style0 from "./dashboardcount.vue?vue&type=style&index=0&id=42043c04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42043c04",
  null
  
)

export default component.exports